<template>
  <Intro />
  <OurCoreValues />
  <OurServices />
  <div class="pt-16"></div>
  <!-- <FAQ /> -->
  <ContactUs />
</template>

<script setup lang="ts">
import HeaderMain from "@/components/shared/header/HeaderMain.vue";
import Intro from "@/components/home/HomeIntro.vue";
import OurCoreValues from "@/components/home/OurCoreValues.vue";
import OurServices from "@/components/home/HomeOurServices.vue";
import FAQ from "@/components/home/FAQ.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";
//import { useI18n } from "vue-i18n";

onMounted(async () => {
  // window.scrollTo(0, 0);
});

//const i18n = useI18n();
</script>

